<div class="d-flex mt-5">
    <div class="m-auto w-100">
        <div class="row mh-30-vh">
            <div class="col mb-3 text-center">
                <img class="img-fluid mh-30-vh" src="../../../assets/img/azul-amarillo.svg" alt="LoCana">
            </div>
        </div>
        <div class="container-fluid w-70 text-center">
            <h2 class="fs-xxl">SE HA DETECTADO UN ERROR</h2>
            <p class="fs-md">Revise la operación o contacte con Nosotros para solucionar el incidente</p>
            <a (click)="contact()" class="pointer">Contactar</a>
        </div>
    </div>
</div>